import ApproveRejectButton from "./ApproveRejectButton"

export default ApproveRejectButton
